import fetchBrands from "./fetchBrands";
import fetchDevices from "./fetchDevices";
import fetchEstablishments from "./fetchEstablishments";
import fetchPacks from "./fetchPacks";
import fetchResidences from "./fetchResidences";
import fetchScreens from "./fetchScreens";
import fetchUser from "./fetchUser";
import fetchUsers from "./fetchUsers";
import fetchDeviceBrands from "./fetchDeviceBrands";
import fetchDeviceTypes from "./fetchDeviceTypes";
import fetchZones from "./fetchZones";

export default async function refreshData(user) {
  await fetchUser(user);

  // Fetch in order with proper await to prevent race conditions
  await fetchDeviceTypes();
  await fetchDeviceBrands();
  await fetchDevices();
  await fetchScreens();
  await fetchBrands();
  await fetchEstablishments();
  await fetchResidences();
  await fetchZones();
  await fetchUsers();
  await fetchPacks();
}
